/**
 * Tiny presentational pieces shared between the report show page (`show.tsx`)
 * and its "Reported content" card (`ReportedContent.tsx`) — pulled out here
 * (fix round 1, item 11) so the two files stop carrying byte-identical copies
 * of the same label/field styling and date formatter.
 */
import React from 'react'
import { brand } from '../../theme/brand'

export const headStyle: React.CSSProperties = {
  fontFamily: brand.fDisplay,
  fontWeight: 700,
  color: brand.ink,
}

export const labelStyle: React.CSSProperties = {
  fontFamily: brand.fSans,
  fontWeight: 700,
  fontSize: 11,
  letterSpacing: '.09em',
  textTransform: 'uppercase',
  color: brand.gold,
  marginBottom: 4,
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={labelStyle}>{label}</div>
      <div style={{ fontFamily: brand.fSans, fontWeight: 500, fontSize: 13.5, color: brand.ink }}>{children}</div>
    </div>
  )
}

/** `null`/`undefined` → an em dash, otherwise a short localized date+time. */
export function fmtDate(v: string | null | undefined): string {
  return v
    ? new Date(v).toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : '—'
}
